<canvas #canvasHtml
        (click)="onCanvasClick($event)"></canvas>
